import { Button, DatePicker, Form, Row, Space } from 'antd';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getSubsidiaries } from '../../../../appRedux/actions';
import { buttonLabel, dateFormat, formConfig } from '../../../../constants';
import { getGeneralAppointment } from '../../../../appRedux/actions/Reports';
import moment from 'moment';

export const GeneralAppointmentReportFilter = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { RangePicker } = DatePicker;

  useEffect(() => {
    dispatch(getSubsidiaries({ status: 1 }));
  }, [dispatch]);

  const onSubmit = (values) => {
    if (values.dates)
      values.dates = values.dates.map((date) =>
        moment(date)?.format(dateFormat)
      );
    dispatch(getGeneralAppointment(values));
  };

  return (
    <Row>
      <Form {...formConfig} onFinish={onSubmit} form={form}>
        <Space>
          <Form.Item name="dates">
            <RangePicker format={dateFormat} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" className="btn-form" htmlType="submit">
              {buttonLabel.search}
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </Row>
  );
};
